import { Navigate, Outlet } from "react-router";
import { useUser } from "@/hooks/useUser.ts";

const ProtectedRoute = () => {
  const user = useUser();

  return user ? <Outlet /> : <Navigate to="/sign-in" replace />;
};

export default ProtectedRoute;
